module.exports = __webpack_public_path__ + "img/i.6be74b8a.jpg";